import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import { NavDireita } from '../../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/SubMenuPages/SubMenuGruposUsuarios/SubMenuGruposUsuarios.css'
import ModalEditar from './modal-GruposDeUsuario/ModalEditarGrupoUser'
import Modal from './modal-GruposDeUsuario/ModalNovoGrupoUser'

function SubMenuGruposUsuarios() {
  const [searchTerm, setSearchTerm] = useState('')
  var user = authService.getCurrentUser()
  const [grupoUsuario, setPessoas] = useState<any[]>([])
  const [modalInfo, setModalInfo] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/grupoUsuario/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setPessoas(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }

  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className="displayInteract">
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo} />
      )}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>CADASTRO DE GRUPOS DE USUÁRIOS</TitlePage1>
            {/* <TitlePage2>Grupos de Usuários</TitlePage2> */}
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <Modal />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>
                <p className="ttlTbl">Permissões</p>
              </th>
              <th>
                <p className="ttlTbl">Grupo</p>{' '}
              </th>
              <th>
                <p className="ttlTbl">Status</p>
              </th>
            </thead>
            <tbody>
              {grupoUsuario
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.gruDescricao
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(grupoUsuario => (
                  <tr key={grupoUsuario.IdGrupoUsuario}>
                    <td>
                      <p className="spaceVinc">
                        <Link
                          to={`/PermissoesDeacessoAoSistema/${grupoUsuario.IdGrupoUsuario}`}
                        >
                          <button className="btnMGUPermissoes">
                            <i className="fas fa-bars"></i>
                          </button>
                        </Link>
                      </p>
                    </td>

                    <td onClick={() => handleToggleComplete(grupoUsuario)}>
                      <p className="Space5">{grupoUsuario.gruDescricao}</p>
                    </td>

                    <td>
                      <p className="spaceVinc">
                        {/* {grupoUsuario.gruStatus} */}
                        <label className="container">
                          <input
                            type="checkbox"
                            defaultChecked={!!grupoUsuario.gruStatus}
                            disabled
                          />
                          <span className="checkmark"></span>
                        </label>
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default SubMenuGruposUsuarios
